// One place for "where this project actually is", shared by the solar model,
// the Google 3D Tiles context and the day/night controller.

// Ad-Diriyah, Riyadh. Exact plot coordinates, supplied for this project.
export const SITE_LAT = 24.734803250568728;
export const SITE_LON = 46.57147355659767;

// Approximate ground elevation above the WGS84 ellipsoid, in metres. Diriyah
// sits on a plateau, not at sea level, and the tiles frame is anchored at the
// ellipsoid surface unless told otherwise: leaving this at 0 buries the scene
// origin ~700 m under the terrain, which puts the whole city above the camera.
// The ground-snap raycast corrects the remainder, this just gets it close.
export const SITE_HEIGHT_M = 660;

// Saudi Arabia is UTC+3 year round (no DST), but go through Intl anyway so the
// clock stays right if that ever changes.
export const SITE_TIMEZONE = 'Asia/Riyadh';
export const SITE_LABEL = 'Diriyah';

// Rotation applied to the masterplan so its grid lines up with the real plot.
// The tiles frame is left unrotated (azimuth 0) on purpose: that keeps scene
// axes geo-aligned (+Z north, +X west), which is what makes the sun land in
// the right part of the sky. Turn the model, not the world.
export const MODEL_HEADING_DEG = 0;

// The model is a maquette: its bounding box is ~8 units across, while Google's
// tiles are in metres. Rather than rescale the model (which would invalidate
// every camera preset, hotspot radius and control distance in the app), the
// tiles are scaled DOWN into the model's units. This is the one number that
// says how big the masterplan is in the real world; adjust it if the plot
// footprint is known precisely.
export const SITE_SPAN_METERS = 420;

// How far the Google terrain is levelled BELOW the masterplan's paving.
//
// Levelling them dead flush looks wrong: the maquette's base has its own kerbs,
// steps and planting beds sitting at slightly different heights, so an exactly
// matched grade swallows the lowest of them and the plot reads as half-buried.
// A small clearance seats the model proud of the plateau instead. Raise it if
// the plot still looks sunk, lower it if it starts to look like a plinth.
export const TERRAIN_CLEARANCE_M = 6;

// Model units per real-world metre, filled in once the model's bounding box is
// known (see main.ts). Everything geo-referenced multiplies by this.
export const sceneScale = { unitsPerMeter: 0.02 };

export function setSceneScaleFromModelWidth(widthInUnits: number): number {
    sceneScale.unitsPerMeter = widthInUnits / SITE_SPAN_METERS;
    return sceneScale.unitsPerMeter;
}

/** Metres expressed in scene units. */
export function m(meters: number): number {
    return meters * sceneScale.unitsPerMeter;
}
